import { PriceRequest } from "../models/PriceRequest";
import { Box } from "../models/Box";
import {BASE_URLS} from "../config/urls";

type CalcResponse = { price: number; volume: number };

export class CalculatorService {
    constructor(
        private baseUrl = `${BASE_URLS.api}/calculator`,
        private timeoutMs = 15000
    ) {}

    async calculate(req: PriceRequest, boxes?: Box[]): Promise<CalcResponse> {
        const body: any = { priceRequestDTO: req };
        if (boxes?.length) body.boxes = boxes;

        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), this.timeoutMs);

        try {
            const res = await fetch(this.baseUrl, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
                signal: controller.signal,
            });

            // Ошибки HTTP
            if (!res.ok) {
                const text = await res.text().catch(() => "");
                throw new Error(
                    `Ошибка ${res.status}: ${res.statusText || "Bad response"}${text ? ` — ${text}` : ""}`
                );
            }

            const data = await res.json();

            if (typeof data?.price === "number" && typeof data?.volume === "number") {
                console.log(data)
                return data as CalcResponse;
            }

            throw new Error("Неожиданный формат ответа калькулятора");
        } finally {
            clearTimeout(timer);
        }
    }
}
